import { render, staticRenderFns } from "./Clips.vue?vue&type=template&id=3ea116e0"
import script from "./Clips.vue?vue&type=script&lang=js"
export * from "./Clips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports